var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{attrs:{"fields":_vm.campos,"items":_vm.items,"show-empty":"","empty-text":_vm.$t('GERAL.NENHUM_REGISTRO'),"head-variant":"light","responsive":"","striped":"","hover":""},on:{"sort-changed":_vm.aoMudarOrdenacao}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }